//STYLE
import style from './styles/index.scss'

//custom script
// import dynamic_contact from './scripts/dynamic_contact'

//import vue
import './vue'
import './scripts/anims/animate'

import $ from 'jquery'

function setDocHeight() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
};
window.addEventListener('resize', function () {
    setDocHeight();
});


$(document).ready(function (){
    setDocHeight();
    let videoHeight = $('#header_video').height()
    let promotialSlide = $('.promotial__slide')
    promotialSlide.css('height', (promotialSlide.height()*100)/1312 + '!important');
})

window.onload = function () {
    // $(".overlay-loader").fadeOut('slow', function (){
        $('.promotial__slide__text--border').addClass('load')
        $('#header-top').removeClass('d-none')
        $('#header-top').addClass('animate__fadeInDown')
        $('#btn-js-animated').removeClass('d-none')
        $('#btn-js-animated').addClass('animate__fadeInUp')
        $('#js-dots-animate').removeClass('opacity-none')
        $('#js-dots-animate').addClass('animate__fadeInRight ')

        $('.text-right-animated').removeClass('opacity-none')
        $('.text-right-animated').addClass('animate__fadeInRightShorter')
        $('.text-left-animated').removeClass('opacity-none')
        $('.text-left-animated').addClass('animate__fadeInLeftShorter')
    // })
};


